import { TextTemplateKey } from "../../components/types";
import { LocalizedTextStateContext } from "../../contexts/localized-text-context-provider";
import { LocalizedTextState } from "../../contexts/types";
import { useContextSafely } from "../../utils/react-utils";

/**
 * A hook that returns a `localizedText` helper function to be used within a `LocalizedTextProvider`.
 *
 * This function takes a `textTemplateKey` (and other optional parameters) and returns the corresponding localized text
 * string, as per the active language.
 *
 * It's optional parameters allow populating the text template with dynamic data, as well as returning the right
 * localized text string for a given tenant, if applicable.
 *
 * @param suppressErrorMessage Suppress console error message when the hook is used without `LocalizedTextProvider`.
 */
export function useLocalizedText<T extends TextTemplateKey>(suppressErrorMessage?: boolean) {
  return useContextSafely<LocalizedTextState<T>>(LocalizedTextStateContext, suppressErrorMessage, useLocalizedText.name)
    ?.localizedText;
}
